<template>
  <div>
  <el-dialog
    :title="editForm.id==null||editForm==''?'登记充电站':'编辑充电站'"
    width="900px"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <!--外部对话框 form-->
    <el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">
      <el-col :span="12">
        <el-form-item label="充电站名称：" :label-width="formLabelWidth" prop="stationName">
          <el-input v-model="editForm.stationName" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电站类型：" :label-width="formLabelWidth" prop="stationType">
          <el-select placeholder="充电站类型" v-model="editForm.stationType">
            <el-option v-for="item in stationTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电站状态：" :label-width="formLabelWidth" prop="stationStatus">
          <el-select placeholder="充电站状态" v-model="editForm.stationStatus">
            <el-option v-for="item in stationStatusData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="桩数量" :label-width="formLabelWidth" prop="pileCount">-->
      <!--              <el-input v-model="editForm.pileCount" autocomplete="off"></el-input>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="是否启用" :label-width="formLabelWidth" prop="canUse">-->
      <!--              <el-select placeholder="请选择" v-model="editForm.canUse">-->
      <!--                <el-option v-for="item in canUseData" :key="item.value"-->
      <!--                           v-bind:label="item.message" v-bind:value="item.value"></el-option>-->
      <!--              </el-select>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <el-col :span="12">
        <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" v-model="editForm.operatorId">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini" ref="cascader"
                        placeholder="运营商"  filterable
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <!--<el-col :span="12">
        <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
          <el-select placeholder="运营商" v-model="editForm.virtualId">
            <el-option v-for="item in operatorForSelect" :key="item.id"
                       :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>-->
      <el-col :span="12">
        <el-form-item label="所在省：" :label-width="formLabelWidth" prop="province">
          <el-input placeholder="上传站点地址后填充"  v-model="editForm.province" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所在市：" :label-width="formLabelWidth" prop="city">
          <el-input placeholder="上传站点地址后填充"  v-model="editForm.city" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="县/区：" :label-width="formLabelWidth" prop="area">
          <el-input placeholder="上传站点地址后填充"  v-model="editForm.area" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
          <el-input autocomplete="off" placeholder="从右边按钮上传站点地址" id="address" v-model="editForm.address"></el-input>
          <el-button @click="showInnerForm">上传
            <i class="el-icon-upload el-icon--right"></i></el-button>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经度：" :label-width="formLabelWidth" prop="longitude">
          <el-input placeholder="上传站点地址后填充"  autocomplete="off" v-model="editForm.longitude"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="纬度：" :label-width="formLabelWidth" prop="latitude">
          <el-input placeholder="上传站点地址后填充"  autocomplete="off" v-model="editForm.latitude"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="地区编码：" :label-width="formLabelWidth" prop="areaCode">
          <el-input v-model="editForm.areaCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="县以下行政区划代码：" :label-width="formLabelWidth" prop="townCode">
          <el-input v-model="editForm.townCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="场站面积/平米" :label-width="formLabelWidth" prop="siteArea">
          <el-input autocomplete="off" v-model="editForm.siteArea"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="地区类型：" :label-width="formLabelWidth" prop="addressType">
          <el-select placeholder="地区类型" v-model="editForm.addressType">
            <el-option v-for="item in addressTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="dutyPerson">
          <el-input autocomplete="off" v-model="editForm.dutyPerson"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="服务电话：" :label-width="formLabelWidth" prop="dutyPersonPhone">
          <el-input autocomplete="off" v-model="editForm.dutyPersonPhone"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营管理费/元：" :label-width="formLabelWidth" prop="managementPrice">
          <el-input autocomplete="off" v-model="editForm.managementPrice"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="营业时间：" :label-width="formLabelWidth" prop="businessHours">
          <el-input autocomplete="off" placeholder="格式00:00-24:00" v-model="editForm.businessHours"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="营业类型：" :label-width="formLabelWidth" prop="businessType">
          <el-select placeholder="营业类型" v-model="editForm.businessType">
            <el-option v-for="item in businessTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="停车场开放时间：" :label-width="formLabelWidth" prop="parkingLotOpenHours">
          <el-input autocomplete="off" placeholder="格式00:00-24:00" v-model="editForm.parkingLotOpenHours"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="停车位数量：" :label-width="formLabelWidth" prop="parkNum">
          <el-input autocomplete="off" v-model="editForm.parkNum"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否收取停车费：" :label-width="formLabelWidth" prop="isParkingFee">
          <el-select placeholder="是否收取停车费" v-model="editForm.isParkingFee">
            <el-option v-for="item in YesNoEnumData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="停车费用(元)/小时：" :label-width="formLabelWidth" prop="parkingLotFee">
          <div v-if="editForm.isParkingFee == 'Y'">
            <el-input autocomplete="off" v-model="editForm.parkingLotFee"></el-input>
          </div>
          <div v-else>
            <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="停车费说明：" :label-width="formLabelWidth" prop="parkingNotice">
            <el-input autocomplete="off" v-model="editForm.parkingNotice" placeholder="例如：免停2小时，2小时后每小时5元"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否启用占桩计费：" :label-width="formLabelWidth" prop="feesTakeUpPile">
          <el-select placeholder="启用占桩计费" v-model="editForm.feesTakeUpPile">
            <el-option v-for="item in feesTakeUpPileData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="占桩计费时长/分钟：" :label-width="formLabelWidth" prop="takeUpTime">
          <div v-if="editForm.feesTakeUpPile == 'Y'">
            <el-input autocomplete="off" placeholder="单位/分钟" v-model="editForm.takeUpTime"></el-input>
          </div>
          <div v-else>
            <el-input autocomplete="off"  value="0" disabled="disabled"></el-input>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="占桩单价(元)/分钟：" :label-width="formLabelWidth" prop="takeUpPrice">
          <div v-if="editForm.feesTakeUpPile == 'Y'">
            <el-input autocomplete="off" v-model="editForm.takeUpPrice"></el-input>
          </div>
          <div v-else>
            <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="快慢充：" :label-width="formLabelWidth" prop="fastOrSlow">
          <el-select placeholder="供移动端展示" v-model="editForm.fastOrSlow">
            <el-option v-for="item in fastOrSlowData" :key="item.value"
                       v-bind:label="item.message+'站'" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="佣金开启充电：" :label-width="formLabelWidth" prop="commissionChargeFlag">
          <el-select placeholder="请选择" v-model="editForm.commissionChargeFlag">
            <el-option v-for="item in YesNoEnumData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否互联互通：" :label-width="formLabelWidth" prop="isCec">
          <el-select placeholder="请选择" v-model="editForm.isCec">
            <el-option v-for="item in isCecData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--     互联互通的     -->
      <div v-if="editForm.isCec == 'Y'">
        <el-col :span="12">
          <el-form-item label="设备所属方id：" :label-width="formLabelWidth" prop="equipmentOwnerID">
            <el-input autocomplete="off" placeholder="公司组织机构代码" v-model="editForm.equipmentOwnerID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充电站国家代码：" :label-width="formLabelWidth" prop="countryCode">
            <el-input autocomplete="off" placeholder="例如CN" v-model="editForm.countryCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区代码：" :label-width="formLabelWidth" prop="areaCode">
            <el-input autocomplete="off" placeholder="省市区编码GB/T 2260-2007" v-model="editForm.areaCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="站点电话：" :label-width="formLabelWidth" prop="stationTel">
            <el-input autocomplete="off" v-model="editForm.stationTel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务电话：" :label-width="formLabelWidth" prop="serviceTel">
            <el-input autocomplete="off" v-model="editForm.serviceTel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="站点引导：" :label-width="formLabelWidth" prop="siteGuide">
            <el-input autocomplete="off" v-model="editForm.siteGuide"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用车型描述：" :label-width="formLabelWidth" prop="matchCars">
            <el-input autocomplete="off" v-model="editForm.matchCars"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车位楼层及数量描述：" :label-width="formLabelWidth" prop="parkInfo">
            <el-input autocomplete="off" v-model="editForm.parkInfo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否支持预约：" :label-width="formLabelWidth" prop="supportOrder">
            <el-select placeholder="请选择" v-model="editForm.supportOrder">
              <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="停车费类型：" :label-width="formLabelWidth" prop="parkType">
            <el-select placeholder="请选择" v-model="editForm.parkType">
              <el-option v-for="item in parkTypeEnumData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电费类型：" :label-width="formLabelWidth" prop="electricityType">
            <el-select placeholder="请选择" v-model="editForm.electricityType">
              <el-option v-for="item in electricityTypeEnumData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否独立报装：" :label-width="formLabelWidth" prop="businessExpandType">
            <el-select placeholder="请选择" v-model="editForm.businessExpandType">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报装电源容量：" :label-width="formLabelWidth" prop="capacity">
            <el-input autocomplete="off" v-model="editForm.capacity"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="站点额定总功率单位kW：" :label-width="formLabelWidth" prop="ratedPower">
            <el-input autocomplete="off" v-model="editForm.ratedPower"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="峰谷分时：" :label-width="formLabelWidth" prop="periodFee">
            <el-select placeholder="请选择" v-model="editForm.periodFee">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="正式投运时间：" :label-width="formLabelWidth" prop="officialRunTime">
            <el-date-picker v-model="editForm.officialRunTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充换电站方位：" :label-width="formLabelWidth" prop="stationOrientation">
            <el-select placeholder="请选择" v-model="editForm.stationOrientation">
              <el-option v-for="item in stationOrientationEnumData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充换电站建设面积：" :label-width="formLabelWidth" prop="stationArea">
            <el-input autocomplete="off" v-model="editForm.stationArea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充换电站人工值守：" :label-width="formLabelWidth" prop="havePerson">
            <el-select placeholder="请选择" v-model="editForm.havePerson">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="视频监控配套情况：" :label-width="formLabelWidth" prop="videoMonitor">
            <el-select placeholder="请选择" v-model="editForm.videoMonitor">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否有小票机：" :label-width="formLabelWidth" prop="printerFlag">
            <el-select placeholder="请选择" v-model="editForm.printerFlag">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否有道闸：" :label-width="formLabelWidth" prop="barrierFlag">
            <el-select placeholder="请选择" v-model="editForm.barrierFlag">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否有地锁：" :label-width="formLabelWidth" prop="parkingLockFlag">
            <el-select placeholder="请选择" v-model="editForm.parkingLockFlag">
              <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供电类型：" :label-width="formLabelWidth" prop="supplyType">
            <el-select placeholder="请选择" v-model="editForm.supplyType">
              <el-option v-for="item in supplyTypeEnumData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供电局用户编号：" :label-width="formLabelWidth" prop="residentNo">
            <el-input autocomplete="off" v-model="editForm.residentNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="表号：" :label-width="formLabelWidth" prop="wattHourMeterNo">
            <el-input autocomplete="off" v-model="editForm.wattHourMeterNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="全省唯一备案号：" :label-width="formLabelWidth" prop="recordUniqueNo">
            <el-input autocomplete="off" v-model="editForm.recordUniqueNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="外电功率：" :label-width="formLabelWidth" prop="forwardPower">
            <el-input autocomplete="off" v-model="editForm.forwardPower"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div v-else></div>
      <!--隐藏id-->
      <el-col :span="12">
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearEditForm">取 消</el-button>
      <el-button size="mini" plain type="primary" @click.native="editSubmit" :loading="editSubmitLoading">提交
      </el-button>
    </div>
  </el-dialog>
  <!--   地图组件   -->
  <el-dialog width="40%" :visible.sync="dialogInnerVisible">
    <!--快速搜索 form-->
    <el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
      <el-tabs v-model="innerFormName">
        <!--经纬坐标-->
        <el-tab-pane label="经纬坐标" name="coordinate">
          <el-row class="el_row_input row_input">
            <el-col :span="10" class="el_col_input">
              <el-form-item label="经度：">
                <el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="2" class="el_col_input">
              <el-form-item label="纬度：">
                <el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
              </el-form-item>
            </el-col>
            <!--                <el-col :span="2">-->
            <!--                  <el-form-item>-->
            <!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
          </el-row>
          <!--百度地图组件-->
          <div class="BaiduMap">
            <baidu-map class="map" :center="centerTemp" :zoom="15" :scroll-wheel-zoom="true"
                       :map-style="{styleJson:styleJson}"
                       map-type="BMAP_NORMAL_MAP" @click="getClickInfo">
              <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                              :autoLocation="true"></bm-geolocation>
              <!--&lt;!&ndash;//添加一个小红点的，并将当前的经纬度写入数据中&ndash;&gt;-->
              <bm-marker :position="centerTemp"></bm-marker>
              <bm-control :offset="{width: '10px', height: '10px'}">
                <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
                  <el-input size="mini" v-model="keyword" placeholder="请输入地名关键字"></el-input> <!-- 这里指代一个自定义搜索框组件 -->
                </bm-auto-complete>
              </bm-control>
              <bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
            </baidu-map>
          </div>
          <!--内部对话框底部当前位置-->
          <el-row class="el_row_input rows_input">
            <el-col :span="24" class="el_col_input">
              <el-form-item>
                <label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="dialogInnerVisible =false ">取 消</el-button>
      <el-button size="mini" plain type="primary" @click="confirmAddress">提交</el-button>
    </div>
  </el-dialog>
  </div>
</template>



<script>
  import {validateInput,validatePhoneThree,validateTime,checkSomePhone} from '../../../../common/validator'
  export default {
    name: "add",
    data() {
      return {
        editFormRules: {
          stationName: [{required: true, message: '请输入站名称', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,15,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          stationType: [{required: true, message: '请选择站类型', trigger: 'blur'}],
          stationStatus: [{required: true, message: '请选择站状态', trigger: 'blur'}],
          canUse: [{required: true, message: '请选择是否启用', trigger: 'blur'}],
          longitude: [{required: true, message: '请上传充电站地址', trigger: 'blur'}],
          latitude: [{required: true, message: '请上传充电站地址', trigger: 'blur'}],
          areaCode: [{message: '请输入地区编码', trigger: 'blur'}],
          address: [{required: true, message: '请选择地址', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,127,true,false,false,false,false,false,false)
            }, trigger: 'blur'}],
          siteArea: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,15,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          // addressType: [{required: true, message: '请选择地区类型', trigger: 'blur'}],
          dutyPerson: [{required: true, message: '请输入负责人', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,10,true,true,false,false,true,false,false)
            }, trigger: 'blur'}],
          dutyPersonPhone: [{required: true, message: '请输入服务电话', trigger: 'blur'},{validator: validatePhoneThree, trigger: 'blur'}],
          managementPrice: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,15,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          businessHours: [{validator: validateTime, trigger: 'blur'}],
          // isParkingFee: [{required: true, message: '请选择是否收取停车费', trigger: 'blur'}],
          parkNum: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,10,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          parkingLotOpenHours: [{validator: validateTime, trigger: 'blur'}],
          parkingLotFee: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,10,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          // feesTakeUpPile: [{required: true, message: '请输入是否启用占桩计费', trigger: 'blur'}],
          parkingNotice:[
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,50,true,false,false,false,false,false,false)
              }, trigger: 'blur'}
          ],
          takeUpTime: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,10,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          takeUpPrice: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,10,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          operatorId: [{required: true, message: '请选择运营商', trigger: 'blur'}],
          // managementPrice: [{required: true, message: '请输入运营管理费', trigger: 'blur'}, {validator: isDecimalThanZero, trigger: 'blur'}],
          fastOrSlow: [{required: true, message: '请选择快慢充', trigger: 'blur'}],
          commissionChargeFlag: [{required: true, message: '请选择是否佣金开启充电', trigger: 'blur'}],
          businessType: [{required: true, message: '请选择营业类型', trigger: 'blur'}],
          isCec: [{required: true, message: '请选择是否互联互通', trigger: 'blur'}],
          townCode: [{
            required: true,
            message: '请输入县以下行政区划代码',
            trigger: 'blur'
          }],
        },
        formLabelWidth: '150px',
        // 百度地图初始化数据
        dialogInnerVisible: false, // 内部对话框
        innerForm: {},
        innerFormName: 'coordinate',
        styleJson: [ // 百度地图自定义
          {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': {
              'color': '#ffffff'
            }
          }
        ],
        baidumapSwitch: false,
        zoom: 16,
        location: '上海市',
        keyword: '',
        centerTemp: {
          lng: 121.384555, lat: 31.069087
        },
        // 设置center属性值
        provinceTemp: '',
        cityTemp: '',
        districtTemp: '',
        addressTemp: '',
        // 营业时间
        business: [
          ["00:00", "24:00"]
        ],
        // 停车场开放时间
        parkingLotOpen: [
          ["00:00", "24:00"]
        ],
        supportingFacilitiesData: [
          { value: 0, message: "其他" },
          { value: 1, message: "卫生间" },
          { value: 2, message: "休息室" },
          { value: 3, message: "便利店" },
          { value: 4, message: "自动洗车" },
          { value: 5, message: "人员值守" },
        ],
        environmentData: [
          { value: 1, message: "地上" },
          { value: 2, message: "地下" },
          { value: 3, message: "地上/地下" },
        ],
        YesNoEnumIntegerData: [
          {value: 1, message: '是'},
          {value: 0, message: '否'}
        ],
        supplyTypeEnumData: [
          {value: 1, message: '直供电'},
          {value: 2, message: '转供电'}
        ],
        parkTypeEnumData: [
          {value: 0, message: '免费'},
          {value: 1, message: '不免费'},
          {value: 2, message: '限时免费停车'},
          {value: 3, message: '充电限时减免'},
          {value: 255, message: '参考场地实际收费标准'}
        ],
        electricityTypeEnumData: [
          {value: 1, message: '商业用电'},
          {value: 2, message: '普通工业用电'},
          {value: 3, message: '大工业用电'},
          {value: 4, message: '其他用电'}
        ],
        stationOrientationEnumData: [
          {value: 1, message: '地面-停车场'},
          {value: 2, message: '地面-路侧'},
          {value: 3, message: '地下停车场'},
          {value: 4, message: '立体式停车楼'}
        ],
      }
    },
    methods:{
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      showInnerForm() {
        this.centerTemp.lng = this.editForm.longitude == null ? 121.384555 : this.editForm.longitude
        this.centerTemp.lat = this.editForm.latitude == null ? 31.069087 : this.editForm.latitude
        this.provinceTemp = this.editForm.province
        this.cityTemp = this.editForm.city
        this.districtTemp = this.editForm.area
        this.addressTemp = this.editForm.address
        this.dialogInnerVisible = true
      },
      // 点击获取到当前经纬度
      getClickInfo(e) {
        const myGeo = new window.BMap.Geocoder()
        myGeo.getLocation(e.point, data => {
          if (data) {
            this.centerTemp = {lng: e.point.lng, lat: e.point.lat}
            this.provinceTemp = data.addressComponents.province
            this.cityTemp = data.addressComponents.city
            this.districtTemp = data.addressComponents.district
            this.addressTemp = data.address
          }
        })
      },
      confirmAddress() {
        //this.editForm.longitude = this.centerTemp.lng
        //this.editForm.latitude = this.centerTemp.lat
        this.editForm.province = this.provinceTemp
        this.editForm.city = this.cityTemp
        this.editForm.area = this.districtTemp
        // this.editForm.address = this.addressTemp
        /*Vue实例创建时，editForm.属性名并未声明，因此Vue就无法对属性执行 getter/setter 转化过程，
        导致editForm属性不是响应式的，因此无法触发视图更新。
        解决的方式有两种，第一种就是显示的声明editForm这个对象的属性
        * 其次也可以使用使用Vue的全局API: $set()赋值*/
        this.$set(this.editForm, 'address', this.addressTemp)
        document.getElementById("address").focus()
        document.getElementById("address").blur()
        this.$set(this.editForm, 'longitude', this.centerTemp.lng);
        this.$set(this.editForm, 'latitude', this.centerTemp.lat);
        this.$refs.editForm.clearValidate("longitude");
        this.$refs.editForm.clearValidate("latitude");
        this.dialogInnerVisible = false
      },

      editSubmit(){
        this.$emit('editSubmit',this.$refs.editForm)
      },
    },
    props:{
      editFormVisible:{
        type:Boolean,
        required:true
      },
      editForm:{},
      editSubmitLoading:false,
      operatorForSelect: '',
      stationTypeData:'',
      stationStatusData:'',
      addressTypeData:'',
      businessTypeData:'',
      YesNoEnumData:'',
      feesTakeUpPileData:'',
      fastOrSlowData:'',
      isCecData:''
    },
    // watch:{
    //   editForm: {
    //     handler(newValue, oldValue) {
    //       // console.log(newValue)
    //     },
    //     deep: true
    //   }
    // },
  }
</script>

<style lang="less" scoped>

  .BaiduMap {
    height: 300px;

  div {
    height: 300px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/add.vue